import React, { useState, useEffect } from 'react';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/toaster';
import { Header } from '@/components/Header';
import { Hero } from '@/components/Hero';
import { Curriculum } from '@/components/Curriculum';
import { VideoSection } from '@/components/VideoSection';
import { MaterialsSection } from '@/components/MaterialsSection';
import { QASection } from '@/components/QASection';
import { Footer } from '@/components/Footer';

const Index = () => {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-background">
        <Header />
        <Hero />
        <Curriculum />
        <VideoSection />
        <MaterialsSection />
        <QASection />
        <Footer />
        <Toaster />
      </div>
    </AuthProvider>
  );
};

export default Index;
